<template>
  <div>
    <p v-if="!isMobile">
      어울링 앱을 이용해주세요.
    </p>
  </div>
</template>

<script>
export default {
  name: "AppRedirect",

  data() {
    return {
      isMobile: true
    };
  },

  mounted() {
    const userAgent = navigator.userAgent;

    if (/android/i.test(userAgent)) {
      window.location.href = "https://play.google.com/store/apps/details?id=kr.sejongbike.bike&hl=ko";
    } else if (/iPhone|iPad|iPod/i.test(userAgent)) {
      window.location.href = "https://apps.apple.com/kr/app/%EC%96%B4%EC%9A%B8%EB%A7%81-%EA%B3%B5%EC%98%81%EC%9E%90%EC%A0%84%EA%B1%B0/id1408417032";
    } else {
      this.isMobile = false;
    }
  }
};
</script>